import { MemberResponse, NonPublicFields } from 'app/gamma/src/types/responses';

// this utility method is almost identical to the one used on server side (changes made for TS)
export const useNonPublicIfAvailable = (
  member: MemberResponse,
  attribute: NonPublicFields,
) => {
  if (member.nonPublic && member.nonPublic[attribute]) {
    return member.nonPublic[attribute];
  }

  return member[attribute];
};
